/**
 * Voyage Log Section Component
 */

import React from 'react';
import { Badge } from '../../../catalyst/badge';

const VoyageLogSection = ({ activeVoyage, logEntries }) => {
  if (!activeVoyage) return null;

  const voyageEntries = logEntries
    .filter(entry => entry.voyageId === activeVoyage.id)
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    .slice(0, 20);

  return (
    <div className="bg-white shadow rounded-lg mb-6">
      <div className="px-5 py-3 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-medium text-gray-900">Voyage Log</h3>
          <Badge color="gray" size="sm">
            {voyageEntries.length} entries
          </Badge>
        </div>
      </div>
      <div className="max-h-80 overflow-y-auto">
        {voyageEntries.length === 0 ? (
          <div className="p-6 text-center text-sm text-gray-500">
            No log entries for this voyage yet. Use quick entries above.
          </div>
        ) : (
          voyageEntries.map(entry => (
            <div key={entry.id} className="px-5 py-2 border-b hover:bg-gray-50">
              <div className="flex items-start gap-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-500">
                      {new Date(entry.timestamp).toLocaleTimeString('en-GB', { 
                        hour: '2-digit', 
                        minute: '2-digit' 
                      })}
                    </span>
                    <Badge color="blue" size="xs">{entry.type}</Badge>
                  </div>
                  <p className="text-sm text-gray-700 mt-0.5">{entry.summary}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default VoyageLogSection;